import { Controller, FormProvider, useForm } from 'react-hook-form';
import { Box, MenuItem, Select, Stack } from '@mui/material';
import styles from '../InviteGroupModal.module.scss';
import TextField from '@mui/material/TextField/TextField';
import Typography from '@mui/material/Typography';
import { Button, Input } from 'tt-ui-lib/core';
import { SendIcon } from 'tt-ui-lib/icons';
import React from 'react';
import { getValidationSchema } from 'utils/validationInviteGroupSchemaGenerator';
import { yupResolver } from '@hookform/resolvers/yup';

const selectSx = {
  padding: '0px',
  color: 'rgba(33, 33, 33, 1)',
  '.MuiOutlinedInput-notchedOutline': {
    borderRadius: '12px',
    border: '1px solid #EFEFEF',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderRadius: '12px',
    border: '1px solid #EFEFEF',
  },
};
const ROLL_ON_TT = [
  {
    name: 'Individual',
    value: 'individual',
  },
  {
    name: 'Business',
    value: 'business',
  },
  {
    name: 'Expert',
    value: 'expert',
  },
  {
    name: 'Investor',
    value: 'investor',
  },
];
const ROLL_IN_GROUP = [
  {
    name: 'Admin',
    value: 'admin',
  },
  {
    name: 'Member',
    value: 'member',
  },
];

export const EmailInviteForm = ({ onClose }) => {
  const validationSchema = getValidationSchema();
  const formOptions = { resolver: yupResolver(validationSchema) };
  const formMethods = useForm(formOptions, { mode: 'all' });

  const {
    handleSubmit,
    formState: { errors },
    setValue,
    control,
    getValues,
    register,
  } = formMethods;

  const onSubmitEmailInvite = (data) => {
    console.log('email invite data::::', data);
  };
  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmitEmailInvite)}>
        <Box className={styles.formFields}>
          <Box className={styles.inputsRow}>
            <TextField
              {...register('firstName', {
                required: true,
              })}
              type="text"
              className={styles.textField}
              label="First name*"
              error={!!errors.firstName}
              helperText={errors.firstName?.message}
            />
            <TextField
              {...register('lastName', {
                required: true,
              })}
              type="text"
              className={styles.textField}
              label="Last name*"
              error={!!errors.lastName}
              helperText={errors.lastName?.message}
            />
          </Box>
          <Controller
            name="tt_roles"
            control={control}
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Select
                displayEmpty
                value={value}
                defaultValue=""
                onChange={onChange}
                sx={selectSx}
                className={styles.select}
              >
                <MenuItem disabled value="">
                  <Box className={styles.menuItem}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography>Suggest a role on TT*</Typography>
                    </Stack>
                  </Box>
                </MenuItem>
                {ROLL_ON_TT.map((item) => (
                  <MenuItem value={item.value}>
                    <Box className={styles.menuItem}>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography>{item.name}</Typography>
                      </Stack>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            )}
          />
          <Controller
            name="group_roles"
            control={control}
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <Select
                displayEmpty
                value={value}
                defaultValue=""
                onChange={onChange}
                sx={selectSx}
                className={styles.select}
              >
                <MenuItem disabled value="">
                  <Box className={styles.menuItem}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography>Suggest a role in the group*</Typography>
                    </Stack>
                  </Box>
                </MenuItem>
                {ROLL_IN_GROUP.map((item) => (
                  <MenuItem value={item.value}>
                    <Box className={styles.menuItem}>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography>{item.name}</Typography>
                      </Stack>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            )}
          />
          <TextField
            {...register('email')}
            type="email"
            className={styles.textField}
            label="Email*"
            error={!!errors.email}
            helperText={errors.email?.message}
          />
          <Controller
            name="invite_comment"
            control={control}
            render={({ field: { value, onChange, ...field } }) => (
              <TextField
                {...field}
                className={styles.textField}
                label="Comment for the invitee"
                disableUnderline
                value={value}
                onChange={onChange}
                multiline
                rows={2}
                error={!!errors.invite_comment}
                helperText={errors.invite_comment?.message}
              />
            )}
          />
          <Controller
            name="note_for_me"
            control={control}
            render={({ field: { value, onChange, ...field } }) => (
              <TextField
                {...field}
                className={styles.textField}
                label="Note for me"
                disableUnderline
                value={value}
                onChange={onChange}
                multiline
                rows={2}
                error={!!errors.note_for_me}
                helperText={errors.note_for_me?.message}
              />
            )}
          />
        </Box>
        <Box className={styles.modalButtons}>
          <Button type="default" onClick={onClose}>
            cancel
          </Button>
          <Button type="primary" isSubmit className={styles.sendBtn}>
            <SendIcon />
            Send
          </Button>
        </Box>
      </form>
    </FormProvider>
  );
};
